//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      option: {
        addBtn: false,
        editBtn: false,
        column: [{
          label: "姓名",
          prop: "name"
        }]
      },
      data: [{
        id: 1,
        name: "small"
      }]
    };
  },
  methods: {
    handleForm: function handleForm(id) {
      this.$router.push({
        path: "/form-detail/index",
        query: {
          id: id
        }
      });
    }
  }
};